import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'
import dayjs from 'dayjs'

/**
 * Maps API schedules into the shape the Syncfusion scheduler renders: start/end as
 * timezone-resolved Date objects, a resolved patient name, and a view-specific
 * `room_id` used as the resource/grouping key (room, staff, or date).
 * `schedule_instance` is stamped so fingerprints stay isolated per doctor calendar.
 */
// The API can send patient: null (e.g. a provider event), so fall back to title or category.
const resolvePatientName = (event: IPatientSchedule): string => {
  const patient = event.patient as Partial<IPatientSchedule['patient']> | null
  if (patient?.name) {
    return patient.name
  }
  const fullName = [patient?.last_name, patient?.first_name].filter(Boolean).join(', ')
  return fullName || event.title || event.category?.name || ''
}

export const mapSchedulesToEvents = (
  schedules: IPatientSchedule[] | undefined,
  timeZone: string,
  getResourceId: (event: IPatientSchedule) => string,
  instanceKey?: string,
): IPatientSchedule[] => {
  if (!schedules) {
    return []
  }

  return schedules.map((event) => ({
    ...event,
    room_id: getResourceId(event),
    schedule_instance: instanceKey,
    start_time: dayjs.tz(`${event.date} ${event.start_time}`, timeZone).toDate(),
    end_time: dayjs.tz(`${event.date} ${event.end_time}`, timeZone).toDate(),
    patient: {
      ...event.patient,
      name: resolvePatientName(event),
    },
  }))
}
